import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import en from 'vuetify/lib/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      dark: {
        appBar: '#373b4f',
        background: '#263238',
        drawer: '#37474F',
        footer: '#373b4f',
        primary: '#37474F',
        secondary: '#373b4f',
        accent: '#779993'
      },
      light: {
        appBar: '#ff3b3b',
        background: '#e8ebf8',
        drawer: '#111111',
        footer: '#ff3b3b',
        primary: '#092A8C',
        secondary: '#ff3b3b',
        accent: '#b2192d'
      }
    }
  },
  lang: {
    locales: { en },
    current: 'en'
  }
})
